import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import ApexCharts from "apexcharts";
import { ApexOptions } from "apexcharts";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { userPerformanceOptions } from "./user-performance.constant";
import Chart from "react-apexcharts";
import { Box, Button } from "@mui/material";
import "./user-performance.scss";

const UserPerformance = (props: any) => {
  const { userPerformanceData, handleAddLeadReports, enableExport } = props;
  const [userPerformanceOption, setUserPerformanceOption] =
    useState<ApexOptions>(userPerformanceOptions);
  const [seriesOption, setSeriesOption] = useState<any>([]);
  const [fileFormat, setFileFormat] = useState<any>({
    value: "pdf",
    label: "PDF",
  });

  const handleExport = async () => {
    try {
      const response = await ApexCharts.exec("user-performances", "dataURI");
      handleAddLeadReports(
        { imageData: response?.imgURI.split(",")[1] },
        { section: "user-performance", format: fileFormat.value }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };

  useEffect(() => {
    if (userPerformanceData) {
      const updatedOptions = {
        ...userPerformanceOption,
        xaxis: {
          categories:
            userPerformanceData?.map((item: any) => item.lead_owner_name) || [],
        },
      };
      setSeriesOption([
        {
          name: "Total Assigned Leads",
          type: "column",
          data:
            userPerformanceData?.map((item: any) => item.total_leads || 0) ||
            [],
          color: "#ED5481",
        },
        {
          name: "Converted Leads",
          type: "column",
          data:
            userPerformanceData?.map(
              (item: any) => item.converted_leads || 0
            ) || [],
          color: "rgba(77, 77, 230, 1)",
        },
      ]);
      setUserPerformanceOption(updatedOptions);
    }
  }, [userPerformanceData]);

  return (
    <Box className="user-performance-wrapper">
      <Box className="cpl-wrapper">
        <Box>
          <Box
            sx={{
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p className="header-text">User Performance</p>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Select
                options={[
                  { value: "pdf", label: "PDF" },
                  { value: "csv", label: "CSV" },
                ]}
                isSearchable={false}
                onChange={(e: any) => setFileFormat(e)}
                value={fileFormat}
                className="select-dropdown"
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: (props) => {
                    return (
                      <components.DropdownIndicator {...props}>
                        <ArrowDropDownIcon
                          style={{ fontSize: 20, color: "black" }}
                        />
                      </components.DropdownIndicator>
                    );
                  },
                }}
              />
              <Button
                variant="outlined"
                onClick={handleExport}
                className="address-edit-button"
                disabled={!enableExport}
              >
                Export
              </Button>
            </Box>
          </Box>
          {userPerformanceData?.length ? (
            <Box sx={{ padding: "0px 20px" }}>
              <Chart
                options={{
                  ...userPerformanceOption,
                  chart: {
                    type: "bar",
                    height: 350,
                    id: "user-performances",
                    toolbar: {
                      show: false,
                    },
                  },
                }}
                series={seriesOption}
                type="line"
                height={350}
              />
            </Box>
          ) : (
            <Box
              sx={{
                padding: "10px 20px",
                display: "flex",
                alignItems: "center",
                aligncontent: "center",
                justifyContent: "center",
                height: "250px",
              }}
            >
              {" "}
              No data available
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default UserPerformance;
